import React from 'react';

import logo_boll from '../assets/boll.png';
import logo_stiftung from '../assets/stiftung.png';


const Sponsors = () => {

    return (
          <div className={"container-fluid mt-5 pt-3 border-top"}>
              <div className={"container"} id={"sponsors"}>
                  <div className={"row"}>
                      <div className={"col-12 text-center"}>
                          <p>Gefördert durch:</p>
                      </div>
                  </div>
                  <div className={"row justify-content-center"}>
                      <div className={"col-12 col-md-4 text-center mb-4"}>
                          <img src={logo_boll} alt={"Logo Marga und Walter Boll-Stiftung"} className={"logos"} />
                      </div>
                      <div className={"col-12 col-md-4 text-center mb-4"}>
                          <img src={logo_stiftung} alt={"Logo Paul und Charlotte Kniese-Stiftung"} className={"logos"} />
                      </div>
                  </div>
              </div>
          </div>
    );
};

export default Sponsors;
